import { Typography, makeStyles } from '@material-ui/core'
import React from 'react'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from 'recharts'

import { PayoutChartDataPoint } from './PayoutsByFund'

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(6),
  },
}))

export const GrantCount = ({ data }: { data: PayoutChartDataPoint[] }) => {
  const classes = useStyles()

  const total = data.reduce((acc, curr) => {
    return (
      acc +
      curr.animal_welfare_count +
      curr.ea_community_count +
      curr.far_future_count +
      curr.global_development_count
    )
  }, 0)

  return (
    <div className={classes.root}>
      <Typography variant="h4" gutterBottom>
        Total Grants
      </Typography>

      <Typography variant="body2" style={{ marginBottom: '1em' }}>
        We&apos;ve made <b>{total}</b> grants so far, across all funds.
      </Typography>

      <GrantCountChart data={data} />
    </div>
  )
}

export const GrantCountChart = ({ data }: { data: PayoutChartDataPoint[] }) => {
  return (
    <>
      <div
        style={{ width: '100%', height: 200, fontFamily: '"Lato", sans-serif' }}
      >
        <ResponsiveContainer>
          <LineChart width={500} height={200} margin={{ right: 5 }} data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              style={{ fontSize: 14, fontWeight: 'bold' }}
              dataKey="name"
            />
            <YAxis style={{ fontSize: 14, fontWeight: 'bold' }} />
            <Line
              type="linear"
              dataKey="far_future_count"
              stroke="#88bf4d"
              strokeWidth={3}
            />
            <Line
              type="linear"
              dataKey="ea_community_count"
              stroke="#a989c5"
              strokeWidth={3}
            />
            <Line
              type="linear"
              dataKey="animal_welfare_count"
              stroke="#f2a86f"
              strokeWidth={3}
            />
            <Line
              type="linear"
              dataKey="global_development_count"
              stroke="#98d9d9"
              strokeWidth={3}
            />
            <Tooltip
              formatter={(value, name) => {
                return [value, fundLabels[name]]
              }}
            />
            <Legend
              formatter={(value: string) => fundLabels[value]}
              wrapperStyle={{ fontSize: 14 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </>
  )
}

const fundLabels: Record<string, string> = {
  animal_welfare_count: 'Animal Welfare',
  ea_community_count: 'EA Infrastructure',
  far_future_count: 'Long-Term Future',
  global_development_count: 'Global Health & Development',
}
